<template>
  <layout title="General Information Security Policy">
    <textFirstSection title="General Information Security Policy" />
    <div class="flex justify-center p-6">
      <div class="mt-6 html-editor max-w-6xl mb-6">
        <p>
          At Youverse, we are committed to ensuring the confidentiality, 
          integrity, and availability of information entrusted to us by our 
          customers, employees, and partners. We consider the implementation 
          of an Information Security Management System (ISMS) as a fundamental 
          requirement for maintaining competitiveness and continuously improving 
          organizational processes. Furthermore, current legislation mandates 
          strict adherence to Information Security principles, encompassing both 
          the legal framework for data protection and specific requirements for 
          service providers.
        </p>
        <p>
          To ensure compliance and operational excellence, Youverse has established 
          this policy with appropriate measures aligned with the international 
          standard ISO 27001:2022:
        </p>
        <ol>
          <li>
            Maintain a robust level of Information Security within Youverse, 
            fostering transparency, trust, and integrity while delivering 
            efficient services that meet the needs of employees and partners.
          </li>
          <li>
            Promote training and awareness among all employees, as well as 
            partners and clients, to strengthen security best practices.
          </li>
          <li>
            Enhance the effectiveness and efficiency of internal processes.
          </li>
          <li>
            Identify, assess, and mitigate risks that may threaten 
            information-processing assets through continuous monitoring 
            and control.
          </li>
        </ol>
        <br />
        <p>
          To achieve these objectives, security procedures have been established 
          and implemented at all levels of the organization. These measures 
          facilitate the continuous improvement of business processes, ensuring 
          that the ISMS remains aligned with Youverse's strategic goals.
        </p>
        <p>
          At Youverse, we recognize that maintaining a high level of security 
          and quality is essential. Therefore, security must be consistently 
          upheld to effectively prevent risks, mitigate potential damages, 
          and ensure business continuity over time.
        </p>
        <br />
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const textFirstSection = () =>
  import(
    /* webpackChunkName: "textFirstSection" */ "../Components/Layout/textFirstSection.vue"
  );
export default {
  components: { layout, textFirstSection },
};
</script>

<style>
@import "../../css/custom.css";
</style>